//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import CRUDGenerico from '../../../../../shared-components/generico/CRUDGenerico';
import RegisterForm from '../../../../../shared-components/generico/RegisterForm';
import InputMoneyOld from '../../../../../shared-components/InputMoneyOld';
import { copyObject } from '../../../../../common/functions/helpers';
import ModalVoltar from '../../../../../shared-components/ModalVoltar';

import TransferenciaDesdobramento from './TransferenciaDesdobramento';


export default {
  name: 'TransferenciaForm',
  extends: CRUDGenerico,
  props: {
    somenteLeitura: Boolean,
    novo: Boolean,
    fluxo: Boolean,
  },
  data() {
    return {
      workflowTransferenciaResources: this.$api.workflowTransferencia(this.$resource),
      transferenciaResource: this.$api.transferencia(this.$resource),
      carregarComponentes: false,
      justificativaReprovacao: '',
      transferencia: {
        tipo: 'TRANSFERENCIA',
        idDesdobramento: null,
        idRepresentante: null,
        vlrDisponivel: 0,
        valor: 0,
        justificativa: '',
        idDesdobramentoDestino: null,
        idRepresentanteDestino: null,
        vlrDisponivelDestino: 0,
        valorDestino: 0,
      },
      justificarTransferencia: {
        observacao: '',
        obrigatorio: false,
      },
      fluxoTransferencia: {},
      podeAprovar: false,
      podeReprovar: false,
      disableButton: false,
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action() {},
      },
    };
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'ORC_TRANSFERENCIA').length;
    },
    canPost() {
      return this.canAccessPage;
    },
    canSearch() {
      return this.canAccessPage;
    },
    valorDestino() {
      return this.transferencia.valor + this.transferencia.valorDestino;
    },
  },
  methods: {
    preencherDesdobramento(id = null) {
      this.transferencia.idDesdobramentoOrigem = id;
    },
    preencherOrcamento(id = null) {
      this.transferencia.idOrcamentoOrigem = id;
    },
    preencherRepresentante(id = null) {
      this.transferencia.idControladorOrigem = id;
    },
    preencherValores(valor) {
      this.transferencia.vlrDisponivel = valor;
    },
    preencherDesdobramentoDestino(id = null) {
      this.transferencia.idDesdobramento = id;
    },
    preencherRepresentanteDestino(id = null) {
      this.transferencia.idControladorDestino = id;
    },
    preencherValoresDestino(valor) {
      this.transferencia.valorDestino = valor;
    },
    openSaveDialog(ref, from) {
      if (!this.canPost) {
        return;
      }
      this.$refs.desdobramento.$validator.validateAll()
        .then(isValid => isValid && this.$validator.validateAll())
        .then(isValid => isValid && this.$refs.desdobramentoDestino.$validator.validateAll())
        .then((isValid) => {
          if (!this.validarValor() || !isValid) {
            return;
          }
          this.setDialogContent(this.$t('message.salvar_novo_transferencia'), this.save, from || this.dialog.from);
          this.openDialog(ref || this.dialog.ref);
        });
    },
    openSaveDialogVoltar() {
      if (!this.canPost) {
        return;
      }
      this.$refs.desdobramento.$validator.validateAll()
        .then(isValid => isValid && this.$validator.validateAll())
        .then(isValid => isValid && this.$refs.desdobramentoDestino.$validator.validateAll())
        .then((isValid) => {
          if (!this.validarValor() || !isValid) {
            return;
          }
          this.save();
        });
    },
    validarValor() {
      if (this.transferencia.valor <= 0) {
        this.$toast.create(this.$t('errors.valor.maior_zero'), 'snack', 3E3);
        return false;
      }
      if (this.transferencia.valor > this.transferencia.vlrDisponivel) {
        this.$toast.create(this.$t('errors.valor.disponivel.excedido'), 'snack', 3E3);
        return false;
      }
      return true;
    },
    save() {
      if (!this.canPost) {
        return;
      }
      const objeto = copyObject(this.transferencia);
      this.transferenciaResource.gravar(objeto)
        .then(this.tratarSalvoSucesso)
        .catch((err) => {
          this.$error(this, err);
        });
    },
    tratarSalvoSucesso(response) {
      this.$router.push({ name: 'orcamento' });

      if (response.data.status === 'APROVADO') {
        this.$toast.create(this.$t('message.transferencia_finalizada'), 'snack', 3E3);
      } else {
        this.$toast.create(this.$t('message.transferencia_enviada_aprovacao'), 'snack', 3E3);
      }
    },
    openCancelDialog() {
      this.$refs.voltarDialog.open();
    },
    cancel() {
      this.voltar();
    },
    voltar() {
      if (this.fluxo) {
        this.$router.push({ name: 'dashboard' });
      } else {
        this.$router.push({ name: 'orcamento' });
      }
    },
    openDialogReprovar(ref, from) {
      const content = this.$t('message.deseja_reprovar_transferencia');
      this.setDialogContent(content, this.openDialogJustificativaReprovar,
        from || this.dialog.from);
      this.openDialog(ref || this.dialog.ref);
    },
    openDialogJustificativaReprovar() {
      this.justificarTransferencia.observacao = '';
      this.justificarTransferencia.obrigatorio = true;
      this.justificarTransferencia.action = this.requestReprovar;

      this.openDialog('justificarDialog');
    },
    requestReprovar() {
      const payload = {};
      payload.observacao = this.justificarTransferencia.observacao;
      const id = this.transferencia.id;
      this.workflowTransferenciaResources.reprovar({ id }, payload)
      .then(() => {
        this.voltar();
        this.$toast.create(this.$t('message.transferencia_reprovado'), 'snack', 3E3);
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
    openDialogAprovar(ref, from) {
      // this.motivo = '';
      if (!this.validarValor()) {
        return;
      }
      const content = this.$t('message.deseja_aprovar_transferencia');
      this.setDialogContent(content, this.requestAprovar, from || this.dialog.from);
      this.openDialog(ref || this.dialog.ref);
    },
    requestAprovar() {
      const id = this.transferencia.id;
      this.workflowTransferenciaResources.aprovar({ id }, { id })
      .then(() => {
        this.voltar();
        this.$toast.create(this.$t('message.transferencia_aprovado'), 'snack', 3E3);
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
    requestPermiteAprovar() {
      this.podeAprovar = false;
      this.podeReprovar = false;
      if (this.fluxo && this.fluxoTransferencia.statusFluxo === 'AGUARDANDO_APROVACAO') {
        const id = this.$route.params.id;
        this.workflowTransferenciaResources.aprovador({ id })
        .then((response) => {
          if (response.data.usuarioHabilitado) {
            this.podeAprovar = true;
            this.podeReprovar = true;
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
      }
    },
    closeDialog(ref, cb) {
      this.$refs[ref].close();
      if (cb) {
        cb();
      }
    },
    setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_novo_registro');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
    carregarTransferencia(id) {
      this.transferenciaResource.obter({ id })
        .then((response) => {
          this.preencherTransferencia(response.data);
        })
        .then(this.carregarFluxo)
        .catch((err) => {
          this.$error(this, err);
        });
    },
    preencherTransferencia(data) {
      this.transferencia.id = data.id;
      this.transferencia.idDesdobramento = data.idDesdobramento;
      this.transferencia.idDesdobramentoDestino = data.idDesdobramentoDestino;
      this.transferencia.idRepresentante = data.idRepresentante;
      this.transferencia.idRepresentanteDestino = data.idRepresentanteDestino;
      this.transferencia.justificativa = data.justificativa;
      this.transferencia.status = data.status;
      this.transferencia.valor = data.valor;
      this.carregarComponentes = true;
    },
    carregarFluxo() {
      if (this.fluxo || this.transferencia.status === 'REPROVADO') {
        this.fluxoTransferencia.usuarioSolicitante = {};
        const id = this.$route.params.id;
        this.workflowTransferenciaResources.status({ id }, { id })
          .then((response) => {
            this.fluxoTransferencia = response.data;
            this.preencherJustificativaReprovacao();
            this.requestPermiteAprovar();
          })
        .catch((err) => {
          this.$error(this, err);
        });
      }
    },
    preencherJustificativaReprovacao() {
      if (this.fluxoTransferencia && this.fluxoTransferencia.passoAtual) {
        this.justificativaReprovacao = this.fluxoTransferencia.passoAtual.observacao;
      }
    },
  },
  beforeMount() {
    if (this.$route.params.id) {
      this.carregarTransferencia(this.$route.params.id);
    } else {
      this.carregarComponentes = true;
    }
  },
  components: {
    RegisterForm,
    TransferenciaDesdobramento,
    InputMoneyOld,
    ModalVoltar,
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/orcamento/transferencia/TransferenciaForm.vue?vue&type=script&lang=js&